import {Module, ActionTree, MutationTree, Store} from 'vuex';
import { RootState } from '@/store/types';
import { registerSubModule } from '@/utils/vueUtils';

import { ChartersRequestViewModel } from '@/modules/ChartersRequestModule/ChartersRequestModule.types';
import { ChartersRequestModel } from '@/modules/ChartersRequestModule/ChartersRequestForm/ChartersRequestForm.types';
import { InitCountries } from '../../api/CountryStateApi';

import {
  submitChartersRequestForm,
} from '@/modules/ChartersRequestModule/ChartersRequestModule.api';
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import { TransactionId } from '@/plugins/utm/SegmentElement';

export interface ChartersRequestModuleState extends TransactionId {
  IsSubmitted: boolean;
}

export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SET_FORM_IS_SUBMITTED = 'SET_FORM_IS_SUBMITTED'; 
export const SET_TRANSACTION_ID = 'SET_TRANSACTION_ID'; 
export const SET_FOLLOW_UP_FORM_IS_SUBMITTED = 'SET_FOLLOW_UP_FORM_IS_SUBMITTED';

const actions: ActionTree<ChartersRequestModuleState, RootState> = {
  async [SUBMIT_FORM]({ state, commit }, model: ChartersRequestModel) {
    //console.log('submitted', model);
    const result = await submitChartersRequestForm(model);
    if (result.IsOk) {
      //console.log('from server', result);
      commit(SET_TRANSACTION_ID, result.Item.transaction_id);
      commit(SET_FORM_IS_SUBMITTED);
    } else {
      //console.log('error', result);
    }
  },
};

const mutations: MutationTree<ChartersRequestModuleState> = {
  [SET_FORM_IS_SUBMITTED](state) {
    state.IsSubmitted = true;
    Vue.nextTick(() => {
      VueScrollTo.scrollTo('#app');
    });
  },
  [SET_TRANSACTION_ID](state, id: number) {
    state.transaction_id = id;
  },
};

const registerModule = registerSubModule<ChartersRequestModuleState, ChartersRequestViewModel>(
  (data: ChartersRequestViewModel) => {
    return {
      namespaced: true,
      state: {
        IsSubmitted: false,
        transaction_id: 0,
      },
      actions,
      mutations,
    } as Module<ChartersRequestModuleState, RootState>;
  },
  'ChartersRequestModule',
);

export default async (store: Store<RootState>, data: ChartersRequestViewModel) => {
  await InitCountries();

  return registerModule(store, data)
}
